module.exports = __webpack_public_path__ + "img/circle-and-flowers.83715992.png";